<template>
  <div style="height: 100%;background-color: white"
       v-loading="loading"
       element-loading-text="加载中，请耐心等待。">
    <div style="height: 20px"></div>
    <div style="height: 50px;margin: 0 20px">
      <el-date-picker v-fixZoom
        :clearable="false"
        v-model="alarmDate"
        type="daterange"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        value-format="yyyy-MM-dd"
        style="margin-right: 10px; width: 400px">
      </el-date-picker>
      <el-button type="primary" @click="getTableData">查询</el-button>
      <el-button icon="el-icon-download" type="success" @click="downloadData">导出</el-button>
    </div>
    <div style="max-height: calc(100% - 100px);margin: 0 20px;overflow-y: auto;">
      <el-table
        v-loading="tableLoading"
        element-loading-text="加载中，请耐心等待。"
        :data="tableData"
        border
        style="width: 100%"
        highlight-current-row
        ref="singleTable">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          label="姓名"
          min-width="70"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.AlarmHandleWithAll[0].p_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="alarmphone"
          label="手机号码"
          min-width="90"
          align="center">
        </el-table-column>
        <el-table-column
          label="地址"
          min-width="130"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.AlarmHandleWithAll[0].h_address}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="服务类型"
          min-width="70"
          align="center">
          <template slot-scope="scope">
            <span>外勤</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="time"
          label="订单时间"
          min-width="140"
          align="center">
        </el-table-column>
        <el-table-column
          label="客服处理人"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.AlarmHandleWithAll[0].customerservicename}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="客服处理时间"
          min-width="140"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.AlarmHandleWithAll[0].handletime}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="客服处理备注"
          min-width="150"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.AlarmHandleWithAll[0].content}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="外勤处理人"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.AlarmHandleWithAll.length > 1">{{scope.row.AlarmHandleWithAll[1].customerservicename}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="外勤处理时间"
          min-width="140"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.AlarmHandleWithAll.length > 1">{{scope.row.AlarmHandleWithAll[1].handletime}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="外勤处理备注"
          min-width="150"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.AlarmHandleWithAll.length > 1">{{scope.row.AlarmHandleWithAll[1].content}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="订单状态"
          min-width="70"
          align="center">
          <template slot-scope="scope">
            <span>{{ getStatus(scope.row.ishandle) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;margin-bottom:10px;text-align: center">
      <el-pagination v-fixZoom
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCells">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {querylaweralarminfo} from '../../api/otherStatistics'
export default {
  name: 'outworkStatistics',
  data () {
    return {
      loading: false,
      alarmDate: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      },
      tableLoading: false,
      tableData: [],
      showTable: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0
    }
  },
  created () {
    let aa = window.location.host
    if (aa === 'elderhealth.wecare-u.net') {
      history.back()
    }
    this.getTimeObj()
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const date = new Date().format('yyyy-MM-dd')
    this.alarmDate = [date, date]
    this.getTableData()
  },
  mounted () {
  },
  methods: {
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },
    getTableData () {
      let data = {
        from: this.alarmDate[0] + ' 00:00:00',
        to: this.alarmDate[1] + ' 23:59:59',
        infotype: 3
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      querylaweralarminfo(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.alarms
      }).catch(() => {})
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTableData()
    },
    getStatus (ishandle) {
      if (ishandle === 0) {
        return '未完成'
      } else if (ishandle === 1) {
        return '已完成'
      }
    },
    downloadData () {
      this.$message({
        type: 'info',
        message: '数据加载中，请耐心等待。',
        duration: 0
      })
      let params = {
        page: 1,
        size: 10
      }
      let data = {
        from: this.alarmDate[0] + ' 00:00:00',
        to: this.alarmDate[1] + ' 23:59:59',
        infotype: 3
      }
      querylaweralarminfo(params, data).then(res => {
        console.log(999, res.data.cnt)
        if (res.data.cnt === 0) {
          this.$message.closeAll()
          this.$message({
            type: 'success',
            message: '暂无信息。'
          })
        } else {
          this.download1(res.data.cnt)
        }
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    download1 (cnt) {
      let params = {
        page: 1,
        size: cnt
      }
      let data = {
        from: this.alarmDate[0] + ' 00:00:00',
        to: this.alarmDate[1] + ' 23:59:59',
        infotype: 3
      }
      querylaweralarminfo(params, data).then(res => {
        console.log(888)
        this.downEndData(res.data.alarms)
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    downEndData (arr) {
      let endArr = []
      for (let i = 0; i < arr.length; i++) {
        let obj = arr[i]
        obj.showName = obj.AlarmHandleWithAll[0].p_name
        obj.showAddress = obj.AlarmHandleWithAll[0].h_address
        obj.showType = '外勤'
        obj.showCustomer = obj.AlarmHandleWithAll[0].customerservicename
        obj.showCustomerTime = obj.AlarmHandleWithAll[0].handletime
        obj.showCustomerContent = obj.AlarmHandleWithAll[0].content
        obj.showLaw = obj.AlarmHandleWithAll[1] ? obj.AlarmHandleWithAll[1].customerservicename : ''
        obj.showLawTime = obj.AlarmHandleWithAll[1] ? obj.AlarmHandleWithAll[1].handletime : ''
        obj.showLawContent = obj.AlarmHandleWithAll[1] ? obj.AlarmHandleWithAll[1].content : ''
        obj.showIsHandle = this.getStatus(obj.ishandle)
        endArr.push(obj)
      }
      this.download2(endArr)
    },
    download2 (arr) {
      // console.log(111, arr)
      let filename = '外勤客服统计'
      import('../../vendor/Export2Excel').then(excel => {
        const tHeader = ['姓名', '手机号码', '地址', '服务类型', '订单时间',
          '客服处理人', '客服处理时间', '客服处理备注', '外勤处理人', '外勤处理时间', '外勤处理备注', '订单状态']
        const filterVal = ['showName', 'alarmphone', 'showAddress', 'showType', 'time',
          'showCustomer', 'showCustomerTime', 'showCustomerContent', 'showLaw', 'showLawTime', 'showLawContent', 'showIsHandle']
        const list = arr
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: filename,
          autoWidth: this.autoWidth
        })
      })
      setTimeout(() => {
        this.$message.closeAll()
      }, 1500)
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticalform/outworkStatistics.vue